const tipoDocumento = [
  { valor: "Pasaporte", etiqueta: "Pasaporte" },
  { valor: "DNI", etiqueta: "DNI" },
  { valor: "LE", etiqueta: "LE" },
  { valor: "LC", etiqueta: "LC" },
  { valor: "CI", etiqueta: "CI" },
];

export default tipoDocumento;
